import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { LogoMark } from "./Logo";
import { useSite } from "../lib/site";

export const WhyUs = () => {
  const { t } = useSite();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="why-us" ref={ref} className="relative py-24 lg:py-36 overflow-hidden" data-testid="why-us-section">
      <motion.img src="/img/sand.jpg" alt="" style={{ y }} className="absolute inset-0 h-[130%] -top-[15%] w-full object-cover opacity-[0.18]" />
      <div className="absolute inset-0 bg-gradient-to-b from-[var(--ink)] via-[#0B0E14]/70 to-[var(--ink)]" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal><p className="eyebrow" data-testid="why-us-eyebrow">{t.why.eyebrow}</p></Reveal>
        <Reveal delay={0.1}>
          <blockquote className="f-display mt-8 max-w-5xl text-3xl sm:text-5xl lg:text-6xl leading-[1.12] text-[var(--sand)]" data-testid="why-us-quote">
            <span className="text-[var(--gold)]">“</span>{t.why.quote}<span className="text-[var(--gold)]">”</span>
          </blockquote>
        </Reveal>
        <div className="mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-[var(--line)]">
          {t.why.items.map((it, i) => (
            <Reveal key={i} delay={i * 0.08} className="group border-b sm:border-e border-[var(--line)] p-7 lg:p-8 transition-colors duration-500 hover:bg-[#131822]/80" data-testid={`why-item-${i + 1}`}>
              <div className="flex items-center justify-between">
                <span className="f-mono text-xs text-[var(--gold)]">0{i + 1}</span>
                <LogoMark className="w-6 h-6 opacity-40 transition-[opacity,transform] duration-500 group-hover:opacity-100 group-hover:-translate-y-1" />
              </div>
              <h3 className="f-display mt-10 text-2xl text-[var(--paper)]">{it.t}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[var(--muted)]">{it.d}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
